import React from 'react';
import { FaIcon } from '../FaIcon';
import { getFieldDescriptionKey } from '../../utils/fieldDescriptions';
import { withTranslation } from 'react-i18next';

// Distancia mínima entre el cartel y el borde de la ventana.
const VIEWPORT_MARGIN = 8;

/**
 * Dónde arranca el cartel: centrado sobre el ícono, pero sin salirse de la ventana. En el selector
 * de Informes el «?» queda cerca del borde izquierdo del modal y, centrado a secas, el cartel (hasta
 * 400px) arrancaba en x negativo y se cortaba a la izquierda.
 */
export const clampedTooltipLeft = (iconCenter, tooltipWidth, viewportWidth) => {
    const centered = iconCenter - tooltipWidth / 2;
    const max = viewportWidth - tooltipWidth - VIEWPORT_MARGIN;
    return Math.max(VIEWPORT_MARGIN, Math.min(centered, max));
};

class FieldHelpIconComponent extends React.Component {
    handleMouseEnter = (e) => {
        const tooltip = e.currentTarget.querySelector('.field-help-tooltip');
        if (tooltip) {
            const rect = e.currentTarget.getBoundingClientRect();
            const iconCenter = rect.left + rect.width / 2;
            tooltip.style.display = 'block';
            tooltip.style.position = 'fixed';
            tooltip.style.top = `${rect.bottom + 5}px`;
            tooltip.style.zIndex = '100000';
            // Se mide ya visible: con display none el ancho es 0.
            const left = clampedTooltipLeft(iconCenter, tooltip.offsetWidth, window.innerWidth);
            tooltip.style.left = `${left}px`;
            tooltip.style.transform = 'none';
            // La flecha sigue apuntando al ícono aunque el cartel se haya corrido.
            tooltip.style.setProperty('--field-help-arrow-left', `${iconCenter - left}px`);
        }
    };

    handleMouseLeave = (e) => {
        const tooltip = e.currentTarget.querySelector('.field-help-tooltip');
        if (tooltip) {
            tooltip.style.display = 'none';
        }
    };

    render() {
        const { fieldId, description, t } = this.props;
        const descriptionKey = getFieldDescriptionKey(fieldId);
        // Sin clave propia, la descripción que trae el catálogo (la de los campos personalizados de
        // GA4, que no se pueden listar a mano: son de cada propiedad).
        const text = descriptionKey ? t(descriptionKey) : description;

        if (!text) {
            return null;
        }

        return (
            <span 
                className="field-help-icon-container"
                onMouseEnter={this.handleMouseEnter}
                onMouseLeave={this.handleMouseLeave}
            >
                <FaIcon iconName="question-circle" className="field-help-icon" />
                <span className="field-help-tooltip">
                    <span className="tooltip-description">{text}</span>
                </span>
            </span>
        );
    }
}

export const FieldHelpIcon = withTranslation()(FieldHelpIconComponent);

